module.exports = __webpack_public_path__ + "static/media/dubai-1.0d1698e3.jpg";